import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
 })
export class MainMenuComponent implements OnInit {
  title = 'بیمه انفرادی سلامت';

  constructor(private router: Router) {
  }
  ngOnInit() {
  }

  redirect() {
    this.router.navigate(['/health/family/basic-information']);
  }
}
